import React from 'react'
import './Projects.css'
import project1 from './../assets/jlpl-1.jpeg';
import project2 from './../assets/dark-shed.avif';
import project3 from './../assets/patiala-school.jpeg';


const Projects = () => {
  return (
    <div className='projects'>
      <div className="project-1">
      <div className="project-detail-header">16 STOREY BUILDING FOR JLPL AT MOHALI</div>
        <img src={project1} alt="" style={{'filter': 'brightness(50%)'}} />
      </div>
      <div className="project-2">
      <div className="project-detail-header">HAVELLS INDUSTRIAL SHED AT BADDI (H.P)</div>
        <img src={project2} alt="" />
      </div>
      <div className="project-3">
      <div className="project-detail-header">CONVENT SCHOOL AT PUNJAB</div>
        <img src={project3} alt="" style={{'filter': 'brightness(50%)'}} />
      </div>
    </div>
  )
}

export default Projects
